import { array } from '@ember/helper';
import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';

import joinClasses from 'webapp/helpers/join-classes';
import safeStyle from 'webapp/helpers/safe-style';
import CommonUiIconComponent from 'webapp/components/common/ui-icon';

import type { Group } from 'webapp/models-custom';

interface Args {
	model: { group: Group | null }; // for now just goals
	canEdit?: boolean;
}

export default class GroupSelectComponent extends Component<Args> {
	@service('model-manager/groups') declare mmGroupsService: Service.ModelManager.Groups;
	@service('navigation-main') declare navigationMainService: Service.NavigationMain;
	@service('account') declare accountService: Service.Account;

	get companyName(): string {
		return this.accountService.company || 'Company';
	}

	get group(): Group | null {
		return this.args.model.group;
	}

	@action
	changeGroup(): void {
		// TODO
	}
	<template>
		<div
			role="button"
			class={{joinClasses
				(array
					"group-select"
					(if @canEdit "group-select--can-edit")
					(unless this.group "group-select--empty")
				)
			}}
			{{on "click" this.changeGroup}}
		>
			{{#if this.group}}
				<div
					class="avatar initials"
					style={{safeStyle this.group.color property="background-color"}}
				>
					<CommonUiIconComponent @name="Team" @size="sm" />
				</div>

				<span>{{this.group.name}}</span>
			{{else}}
				{{!-- <span>{{this.companyName}}</span> --}}
			{{/if}}
		</div>
	</template>
}
